module.exports = __webpack_public_path__ + "static/media/sig.e15e0b72.png";